/* eslint-disable lines-between-class-members */
/**
 * ! Each time a new feature flag is added by back office,
 * ! the change must be made in this file too.
 */
import { Expose } from "class-transformer";

import { BaseModel } from "./base.model";

export class ProductFeatures extends BaseModel {
    @Expose() carWorkshops = false;
    @Expose() clinics = false;
    @Expose() downloadPolicies = false;
    @Expose() infoCovid = false;
    @Expose() medicationDelivery = false;
    @Expose() travelAssistance = false;
    @Expose() vehicleAssistance = false;
    @Expose() displayPayments = false;
    @Expose() displayInfo = false;
    @Expose() healthCard = false;
    @Expose() coverNote = false;
    @Expose() healthReimbursementRequest = false;
    @Expose() healthReimbursementTracking = false;
}
